import cookies from 'js-cookie';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { signInWithCustomToken, inMemoryPersistence } from 'firebase/auth';

import * as auth from 'endpoints/auth/client';
import { sessionIn } from 'endpoints/auth';
import { ApiResponse } from 'endpoints/endpoint';
import { auth as firebaseAuth } from 'firebase-service/firebase-client';

export const signIn = createAsyncThunk<
  ApiResponse<auth.SignInResult, auth.SignInError>,
  auth.SignInParams,
  { rejectValue: string }
>('client/signIn', async (data, { rejectWithValue }) => {
  try {
    const response = await auth.signIn(data).invoke();
    const errorMessage = 'details' in response ? response.details : 'StopBroadcastError';

    if (response.success) {
      await firebaseAuth.setPersistence(inMemoryPersistence);
      await signInWithCustomToken(firebaseAuth, response.token);

      const idToken = await firebaseAuth.currentUser?.getIdToken(/* forceRefresh */ true);
      const csrfToken = cookies.get('__csrfToken');

      if (idToken && csrfToken) {
        await sessionIn({ idToken, scope: 'client' }).invoke();
        await firebaseAuth.signOut();

        if (!response.uid && data.uid) response.uid = data.uid;

        return response;
      }
    }

    throw new Error(errorMessage);
  } catch (e) {
    return rejectWithValue((e as Error).message);
  }
});
